var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFactoryProductSortation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#BAD5DB",
  d: "M4.3 19.1V4.5L1.9 6.6"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#42A5F2",
  d: "M21.7 8.5v13l2.4-2.1M7.3 11.6H19"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#86A7B2",
  d: "M18.7 19.3H7.4c-.3 0-.6-.3-.6-.6V9.1c0-.3.3-.6.6-.6h11.3c.3 0 .6.3.6.6v9.7c-.1.3-.3.5-.6.5z"
}))));
export default SvgFactoryProductSortation;